import useGetGenericArticles from '@/hooks/adminTecdoc/useGetGenericArticles'
import { Button, Input, message, Modal, Select, Skeleton, Spin, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { CheckOutlined } from '@ant-design/icons'
import useCreateCategory from '@/hooks/adminTecdoc/useCreateCategory'
import api from '@/services/api'
import { useSelector } from 'react-redux'


const DispatchGenericArticleToCategory = ({ onCreate, show, onCancel, categoryId }) => {

    const language = useSelector((e) => e.settings.Language)

    const [genericArticles, setGenericArticles] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchGenericArticles = async () => {
        setLoading(true);
        try {
            let list = await api()({
                url: `webshop/management/tecdoc-menu-install/generic-articles/find?categoryId=${categoryId}&selectedLanguage=${language?.toUpperCase()}`,
                method: 'GET'
            });
            setGenericArticles(list.data.data);
        } catch (error) {
            message.error('Error fetching generic articles');
        } finally {
            setLoading(false);
        }
    };


    const onSelectHandler = async (genericArticleId) => {


        const createData = {
            categoryId: categoryId,
            genericArticleId: genericArticleId,
        }

        //webshop/management/tecdoc-menu-install/generic-articles/create

        try {
            let response = await api()({
                url: `webshop/management/tecdoc-menu-install/generic-articles/create`,
                method: 'POST',
                data: createData
            });
            onCreate(true)
            message.success('Generic article added successfully');

        } catch (error) {
            console.log(error);
            message.error('Error adding generic article');
        } finally {
            fetchGenericArticles();
        }


    }

    useEffect(() => {

        fetchGenericArticles();
    }, [])



    return (
        <Modal footer={null} title="New generic articles" width={'40%'} open={show} onCancel={onCancel}>

            <Spin spinning={loading}>
                <Select
                    style={{ width: '100%' }}
                    onSelect={onSelectHandler}
                    showSearch
                    placeholder="Select a category"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                        const searchText = input?.toLowerCase();
                        const labelText = (option?.text ?? '').toLowerCase();
                        const valueText = (option?.value ?? '').toString().toLowerCase();

                        return labelText.includes(searchText) || valueText.includes(searchText);
                    }}
                    options={genericArticles.map(e => ({
                        label: (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography.Text>
                                    {e?.label + ` (${e?.value})`}
                                </Typography.Text>
                                {e?.id && <CheckOutlined />}
                            </div>
                        ),
                        value: e?.value,
                        text: e?.label + ` (${e?.genericArticleId})`,
                    }))}
                    size="large"
                />

            </Spin>

        </Modal>
    )
}

export default DispatchGenericArticleToCategory